import { gtagCategoricalEvent } from '../../utils'

export const sweepstakesEvent = gtagCategoricalEvent('sweepstakes')
